export default class PhpRegex {
  static parse(pattern) {
    try {
      const delimiter = pattern.substr(0, 1);
      const flags = pattern.substr(pattern.lastIndexOf(delimiter));
      const inside = pattern.substr(1, pattern.length - flags.length - 1);
      return new RegExp(inside, flags.substr(1));
    } catch {
      return null
    }
  }
}
